import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { registerLicense } from '@syncfusion/ej2-base'

//Profile Syncfusion license
registerLicense('ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Qd0xiWnpZdXRUQWVc')

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
